
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Component_29_6","data-name":"Component 29 – 6","xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_16408","data-name":"Rectangle 16408","width":"15","height":"15","fill":"none"}}),_c('g',{attrs:{"id":"Group_48356","data-name":"Group 48356","transform":"translate(3.899 1.721)","stroke":"#727998"}},[_c('path',{attrs:{"id":"Path_37748","data-name":"Path 37748","d":"M6.547 4.736a1.06 1.06 0 00-.864-.735 1.428 1.428 0 00-.305-.014L5.101.677h.723a.362.362 0 00.254-.1.328.328 0 00.106-.241.35.35 0 00-.361-.333H1.417a.339.339 0 00-.057.675h.78l-.277 3.31h-.136a1.125 1.125 0 00-.305.04 1.056 1.056 0 00-.74.71L.017 7.345a.331.331 0 00.185.392 6.6 6.6 0 002.718.751c.175.011 1.245.017 1.427.007a6.4 6.4 0 002.69-.75.332.332 0 00.185-.4z","fill":"none","stroke-miterlimit":"10","stroke-width":"1.2"}}),_c('path',{attrs:{"id":"Path_37749","data-name":"Path 37749","d":"M2.915 8.487v2.17l.7 1.007.723-1.007V8.494z","fill":"#727998","stroke-linejoin":"round","stroke-width":".2"}})])])
          )
        }
      }
    